export default "__VITE_ASSET__6xB9mcR0__"